import { rj } from "react-rocketjump"
import rjList, {
  nextPreviousPaginationAdapter,
} from "react-rocketjump/plugins/list"
import api from "../api"
import { PAGE_SIZE, PAGE_SIZE_BIG } from "../consts"

export const ProdottoState = rj(
  rjList({
    pagination: nextPreviousPaginationAdapter,
    pageSize: PAGE_SIZE,
  }),
  {
    mutations: {
      removeProdotto: {
        effect: (t) => (entity) =>
          api
            .auth(t)
            .mapResponse(() => entity)
            .delete(`/api/prodotti/${entity.id}`),
        updater: "deleteItem",
        // Uncomment to make delete optimistic
        // optimistiResult: entity => entity,
      },
      addProdotto: {
        effect: (t) => (entity) => api.auth(t).post("/api/prodotti", entity),
        updater: "insertItem",
      },
      updateProdotto: {
        effect: (t) => (entity) =>
          api.auth(t).put(`/api/prodotti/${entity.id}/`, entity),
        updater: "updateItem",
      },
    },
    name: "ProdottoState",
    effectCaller: "configured",
    effect: (t) => (params = {}) => api.auth(t).get("/api/prodotti", params),
    computed: {
      pagination: "getPagination",
      list: "getList",
      loading: "isLoading",
    },
  }
)

export const ProdottoBigState = rj(
  rjList({
    pagination: nextPreviousPaginationAdapter,
    pageSize: PAGE_SIZE_BIG,
  }),
  {
    name: "ProdottoBigState",
    effectCaller: "configured",
    effect: (t) => (params = {}) => api.auth(t).get("/api/prodotti-autocomplete", params),
    computed: {
      pagination: "getPagination",
      list: "getList",
      loading: "isLoading",
    },
  }
)
